import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Grid, Stack} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import Box from "@mui/material/Box";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
  InputBase,
  Divider,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {AGENT_CLIENTS} from "../../../constants/apiConstant";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {initialFormValidations, removeCookies} from "../../../constants/helper";
import debounce from "lodash/debounce";
import NoDataComponent from "../../no-data";
import {styled, alpha} from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({theme}) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
        ...theme.applyStyles("dark", {
          color: "inherit",
        }),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const rows = Array.from({length: 9}, (_, index) => ({
  id: index + 1,
  customername: "John Doe",
  // policyNumber: "PROP10292024-1540",
  contact: "9876543210",
  email: "a@aaa.com",
  company: "Task source",
  // TOL: "Shipping",
  // details: "Received",
}));

const Clients = () => {
  const {type} = useParams();
  // console.log("type", type);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {clientList, clientCount, clientsParentProposal} =
    useSelector(selectDataStoreState);
  const {showLoader} = useSelector(selectUiState);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const clients = useMemo(
    () => (clientList?.length ? clientList : []),
    [clientList]
  );
  const currentRowData = useMemo(() => currentRow, [currentRow]);
  // console.log("clients", clientList);

  const [openEndorseForm, setClaimForm] = useState(false);
  // const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };
  const handleClose = () => {
   setAnchorEl(null);
  setSelectedItem(null);
  };

  const fetchClients = useCallback(async () => {
    if (page === null || rowsPerPage === null) {
      return;
    }
    dispatch(setUiData({showLoader: true}));

    let data = {
      agent_id: user?.id,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };
    // dispatch(setUiData({ showLoader: false }));
    // return;
    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();
      if (res.status == 1) {
        dispatch(
          setDataStore({
            clientList: res?.user_list || [],
            clientCount: res?.total_count || 0,
          })
        );
      } else {
        console.error("Error fetching clients");
      }
      dispatch(setUiData({showLoader: false}));
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      dispatch(setUiData({showLoader: false}));
      navigate("/");
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Prevent the second fetch caused by Strict Mode
    //   return;
    // }
    fetchClients();
  }, [fetchClients]);
  const [values, setValues] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim()) {
      setValues([...values, inputValue.trim()]);
      setInputValue("");
      event.preventDefault();
    }
  };

  const handleDelete = (chipToDelete) => {
    setValues(values.filter((value) => value !== chipToDelete));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const clientSearch = async (searchTerm) => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      search: searchTerm,
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        return res?.user_list ?? [];
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
        return [];
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      console.error("Error:", error);
      dispatch(setUiData({showLoader: false}));
      navigate("/");
      return [];
    }
  };

  const loadOptions = async (inputValue) => {
    const normalizedInput = inputValue.toLowerCase();
    const clients = await clientSearch(normalizedInput);
    dispatch(
      setDataStore({
        clientList: clients || [],
        clientCount: clients?.length || 0,
      })
    );
    // return clients.map((client) => ({
    //     ...client,
    //     label: (
    //         <>
    //             {client.first_name} {client.last_name} <br />
    //             <small>{client?.email}</small>
    //         </>
    //     ),
    //     value: client.user_id,
    // }));
  };

  const debouncedLoadOptions = debounce(loadOptions, 500);

  const handleSelect = (clientSelected, type, jbtype) => {
    console.log(clientSelected)
    dispatch(
      setDataStore({
        jewelers_block_type: jbtype,
        proposalStep: 1,
        proposal_id: null,
        previous_proposal_id: null,
        editingSubmitted: false,
        clickedSteps: [],
        formValidations: initialFormValidations,
      })
    );
    dispatch(setAuthData({selectedClient: clientSelected}));
    if (type === 2) {
      navigate("/diamond-form");
    } else {
      navigate("/new-proposal");
    }
  };

  const handleClientDetails = (row) => {
    navigate("/details/client/" + row.user_id);
  };

  const handleAddClient = (row) => {
    navigate("/client-registration");
  };

  const columns = [
    
    {id: "id", label: "#", minWidth: 25},
    {
      id: "company",
      label: "Company Name",
      minWidth: 160,
      renderCell: (item) => (
        <div>
          <Link to={"/details/client/" + item.user_id} style={{color: "#000"}}>
            {item.company}
          </Link>
        </div>
      ),
    },
    {
      id: "full_name",
      label: "Client Name",
      minWidth: 160,
      // renderCell: (item) => (
      //   <div>
      //     <Link to={"/details/client/" + item.user_id} style={{ color: "#000" }}>
      //       {item.full_name}
      //     </Link>
      //   </div>
      // ),
    },
    // { id: "policyNumber", label: "Policy Number", minWidth: 160 },
    {id: "mobile_no", label: "Contact Number", minWidth: 110},
    {id: "email", label: "Email", minWidth: 110},
    // { id: "TOL", label: "Type of Loss", minWidth: 100 },
    {
      id: "Action",
      label: "Action",
      minWidth: 150,
      
      renderCell: (item) => (
       
        <>
          {/* <Button
            variant="contained"
            style={{ background: "#004F71", marginRight: 10 }}
            onClick={() => {
              handleSelect(item, 1);
            }}
          >
            Jewelers Block
          </Button> */}
          <Button
            id="demo-customized-button"
            aria-controls={open ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            sx={{mr: 1}}
            onClick={(e) => handleClick(e, item)}
            endIcon={<KeyboardArrowDownIcon />}
            style={{background: "#004F71", marginRight: 10}}
          >
            Jewelers Block
          </Button>
          <StyledMenu
            id="demo-customized-menu"
            slotProps={{
              list: {
                "aria-labelledby": "demo-customized-button",
              },
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {/* <MenuItem onClick={() => handleSelect(item, 1, 0)} disableRipple>
              NON LLOYDS APPLICATION
            </MenuItem>
            <Divider sx={{my: 0.5}} />

            <MenuItem onClick={() => handleSelect(item, 1, 1)} disableRipple>
              LLOYDS APPLICATION
            </MenuItem> */}

            <MenuItem
  onClick={() => {
    handleSelect(selectedItem, 1, 0);
    handleClose();
  }}
>
  NON LLOYDS APPLICATION
</MenuItem>

<MenuItem
  onClick={() => {
    handleSelect(selectedItem, 1, 1);
    handleClose();
  }}
>
  LLOYDS APPLICATION
</MenuItem>
          </StyledMenu>
          <Button
            variant="contained"
            style={{background: "#004F71"}}
            onClick={() => {
              handleSelect(item, 2);
            }}
          >
            Processing Risk
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    const paginationInputs = document.querySelectorAll(
      ".MuiSelect-nativeInput"
    );
    paginationInputs.forEach((input, index) => {
      // Add aria-label only if not already present
      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", `Page number input ${index + 1}`);
      }
    });
  }, []);

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2, mb: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>

              <Typography sx={{color: "text.primary"}}>Clients</Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}} className="client_search_main">
            <div className={style.client_search_main}>
              <div className={style.c_Page_title}>
                <h3> Clients </h3>
              </div>

              <Stack direction="row" spacing={2} alignItems="center">
                <Paper
                  component="form"
                  sx={{p: "2px 4px", display: "flex", alignItems: "center"}}
                  className={style.clientSearch}
                >
                  <InputBase
                    sx={{ml: 1, flex: 1}}
                    placeholder="Search Client"
                    inputProps={{"aria-label": "client search box"}}
                    onChange={(e) => debouncedLoadOptions(e.target.value)}
                  />
                  <Divider sx={{height: 28, m: 0.5}} orientation="vertical" />
                  <IconButton
                    type="button"
                    sx={{p: "10px"}}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
                <Box className={style.addClientBtn}>
                  <Button
                    onClick={handleAddClient}
                    variant="contained"
                    type="button"
                  >
                    {" "}
                    Add Client{" "}
                  </Button>
                </Box>
              </Stack>
            </div>

            <Paper className={style.propTableMain}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          style={{minWidth: column.minWidth}}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {clients?.length > 0 ? (
                    <TableBody>
                      {/* {clients.map((row, id) => (
                        <TableRow key={row.id}>
                          <TableCell>{id + 1}</TableCell>
                          <TableCell>{row.full_name}</TableCell> */}
                      {/* <TableCell>{row.policyNumber}</TableCell> */}
                      {/* <TableCell>{row.mobile_no}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{row.company}</TableCell> */}
                      {/* <TableCell>{row.dateReported}</TableCell> */}
                      {/* <TableCell>{row.DOL}</TableCell>
                          <TableCell>{row.estimatedLoss}</TableCell>
                          <TableCell>{row.TOL}</TableCell> */}
                      {/* <TableCell>
                            <Button
                              variant="contained"
                              onClick={() => handleClientDetails(row)}
                              // disabled
                              style={{ background: "#004F71" }}
                            // className={style.IssuedPolicyBtnSucces}
                            >
                              View
                            </Button> */}
                      {/* <Button disabled style={{ color: "#ff8607" }} className={style.IssuedPolicyBtnDanger}>  {row.claimStatus} </Button>
                            <Button disabled style={{ color: "#ff3d32" }} className={style.IssuedPolicyBtnExpired}>  {row.claimStatus} </Button> */}
                      {/* </TableCell>
                        </TableRow>
                      ))} */}
                      {clients.map((row, rowIndex) => (
                        <TableRow key={row.id}>
                          {columns.map((column) => {
                            let value;
                            if (column.id === "id") {
                              value = rowIndex + 1;
                            } else {
                              value = row[column.id];
                            }
                            return (
                              <TableCell
                                key={column.id}
                                style={{minWidth: column.minWidth}}
                              >
                                {column.renderCell
                                  ? column.renderCell({...row, value})
                                  : value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : null}
                </Table>
                {clients?.length > 0
                  ? null
                  : !showLoader && <NoDataComponent />}
              </TableContainer>
              {clients?.length > 0 ? (
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50]}
                  component="div"
                  count={clientCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default Clients;
